import { useAppSelector } from "../store/hooks";

// Per-env deep-link host (with scheme) used to build `deep_link_url`.
// Returns "" when not configured so callers can hide or gate the URL.
export const useAffiliateDeepLinkBaseUrl = (): string =>
  useAppSelector(
    (state) => state.config.appConfig?.affiliates_config?.deeplink_base_url,
  ) ?? "";

export default useAffiliateDeepLinkBaseUrl;
